import { create } from 'zustand';
import type { PersistableTramiteFilters } from '@/hooks/useTramites/types';

const EMPTY_FILTERS: PersistableTramiteFilters = {
  activeSearchText: '',
  sortField: 'id',
  sortDirection: 'desc',
  dateFrom: '',
  dateTo: '',
  dateField: 'fecini',
  escrituraFilter: '',
  registroFilter: '',
  estadoFilter: '',
  bloqueadaFilter: '',
  archivadoFilter: '',
  assignedUserId: '',
  assignedUser: null,
};

export interface TramitesFiltersStoreState {
  filters: PersistableTramiteFilters;
  isInitialized: boolean;
  lastUserId: number | null;
  initialize: (filters: PersistableTramiteFilters, userId: number | null) => void;
  setFilters: (partial: Partial<PersistableTramiteFilters>) => void;
  replaceFilters: (filters: PersistableTramiteFilters) => void;
  resetToDefaults: (defaults: PersistableTramiteFilters, userId: number | null) => void;
  clear: () => void;
}

export const useFiltersStore = create<TramitesFiltersStoreState>((set) => ({
  filters: EMPTY_FILTERS,
  isInitialized: false,
  lastUserId: null,

  initialize: (filters, userId) =>
    set({
      filters,
      isInitialized: true,
      lastUserId: userId,
    }),

  setFilters: (partial) =>
    set((state) => ({
      filters: {
        ...state.filters,
        ...partial,
      },
      isInitialized: true,
    })),

  replaceFilters: (filters) =>
    set({
      filters,
      isInitialized: true,
    }),

  resetToDefaults: (defaults, userId) =>
    set({
      filters: defaults,
      isInitialized: true,
      lastUserId: userId,
    }),

  clear: () =>
    set({
      filters: EMPTY_FILTERS,
      isInitialized: false,
      lastUserId: null,
    }),
}));
